const isDisabledJumio = window.env.DISABLE_JUMIO;
const isDisabledRecaptcha = window.env.DISABLE_RECAPTCHA;
const MOCK_JUMIO = window.env.MOCK_JUMIO;

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export { monthNames, isDisabledJumio, MOCK_JUMIO, isDisabledRecaptcha };
